import { call, put, spawn, takeEvery } from 'redux-saga/effects';
import { receiveCategories } from '../../services/actions/categoriesActions';
import { PRODUCTS, setFavorites } from '../../services/actions/productsActions';
import { receiveSearchTerms, receiveSearchTermsError } from '../../services/actions/searchActions';
import { getFavoritesData } from '../../services/api/products';
import { getCategories, getSearchTerms } from '../../services/api/sale';

const { REQUEST_FAVORITES } = PRODUCTS;

// watcher sagas
export function* watchFetchSaleData() {
  yield takeEvery(REQUEST_FAVORITES, fetchFavoritesData);
}

// worker sagas
// These are calls made when the sale page loads

export function* fetchSaleData() {
  /* using spawn so that these workers stay independent of each other even if they fail.
    https://redux-saga.js.org/docs/advanced/ForkModel.html#detached-forks-using-spawn */
  yield spawn(fetchFavoritesData);
  yield spawn(fetchCategories);
  yield spawn(fetchSearchTerms);
}

function* fetchCategories() {
  const categoriesResponse = yield call(getCategories);
  yield put(receiveCategories(categoriesResponse.categories));
}

function* fetchFavoritesData() {
  const favortiesData = yield call(getFavoritesData);
  yield put(setFavorites(favortiesData));
}

function* fetchSearchTerms() {
  try {
    const response = yield call(getSearchTerms);
    const {
      data: { items },
    } = response;
    yield put(receiveSearchTerms(items));
  } catch (err) {
    yield put(receiveSearchTermsError(err));
  }
}
